import { render, staticRenderFns } from "./EstimateCommission.vue?vue&type=template&id=2ebf634f&scoped=true&"
import script from "./EstimateCommission.vue?vue&type=script&lang=js&"
export * from "./EstimateCommission.vue?vue&type=script&lang=js&"
import style0 from "./EstimateCommission.vue?vue&type=style&index=0&id=2ebf634f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebf634f",
  null
  
)

export default component.exports